import React, { useState } from "react";
import '../../Styles/Purchaseorder.css';
import FormField from "../../../component/formFiedl";
import { simpleGetCallWithErrorResponse } from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";

const RawMaterialRow = () => {
    const fields = ["Material", "Qty", "Unit", "Lot No"];
    return (
        <div className="raw-material-row">
            {fields.map((field) => (
                <div key={field} className="raw-field">
                    <strong><label>{field}</label></strong>
                    <input type="text" className="input" placeholder={field} />
                </div>
            ))}
        </div>
    );
};

const Manufacturing = () => {


    const initialDetails = {
        "BatchNo": "",
        "Date": "",
        "FinishedGoodId": '',
        "Quantity": '',
        "WarehouseId": '',
        "OrgId": 1,
        "ClientEntityId": 31,
        "EntryBy": 4916,
        "IsActive": true,
    }

    const initialMaterials = [
        {
            "MaterialId": 23,
            "Quantity": 10,
            "Unit": "pcs",
            "LotNo": "CPU-LOT-1001",
            "OrgId": 1,
            "ClientEntityId": 31,
            "EntryBy": 4916,
            "IsActive": true
        }
    ]

    const [details, setDetails] = useState(initialDetails)
    const [materials, setMaterials] = useState(initialMaterials)
    const [errorMsg, setErrorMsg] = useState({})

    const handleChange = (key, value) => {

        setDetails(prev => ({
            ...prev,
            [key]: value
        }))

    }


    // const getFinishedGoods = () => {

    //     simpleGetCallWithErrorResponse(ApiConfig)

    // }

    const handleSubmit = () => {

        setErrorMsg(prev => ({
            ...prev,
            BatchNo: !details?.BatchNo ? 'Please Enter Batch No' : '',
            Quantity: !details?.Quantity ? 'Please Enter Quantity' : '',
            WarehouseId: !details?.WarehouseId ? 'Please Select WareHouse' : '',
            FinishedGoodId: !details?.FinishedGoodId ? 'Please Select Finished Good' : '',
            Date: !details?.Date ? 'Please Select Date' : '',

        }))

    }

    return (
        <div className="purchase-order-form">



            <div className="card">
                <h2>Manufacture Finished Goods</h2>

                <div className="form-grid">
                    <FormField placeholder="Batch No"
                        value={details?.BatchNo}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'BatchNo'}
                        validationErr={errorMsg?.BatchNo}
                    />
                    <FormField type="date"
                        value={details?.Date}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'Date'}
                        validationErr={errorMsg?.Date}
                    />
                    <FormField placeholder="Finished Good"
                        type='select'
                        value={details?.FinishedGoodId}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'FinishedGoodId'}
                        validationErr={errorMsg?.FinishedGoodId}
                    />
                    <FormField placeholder="Quantity"
                        value={details?.Quantity}
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'Quantity'}
                        validationErr={errorMsg?.Quantity}
                    />
                    <FormField placeholder="Warehouse"
                        value={details?.WarehouseId}
                        type='select'
                        onChange={(key, value) => {


                            handleChange(key, value)
                        }}
                        valKey={'WarehouseId'}
                        validationErr={errorMsg?.WarehouseId}
                    />
                </div>

                <h3>Raw Material Consumption</h3>
                <RawMaterialRow />

                <div className="form-buttons">
                    <button className="btn submit"
                        onClick={handleSubmit}
                    >Record Manufacturing</button>
                </div>
            </div>
        </div>
    );
};

export default Manufacturing;
